<template>
  <div>
    <v-row justify="center" no-gutters>
      <v-col xl="12" lg="12" md="12" sm="10" cols="12">
        <v-row justify="center" class="pt-xl-6 pt-lg-6 pt-md-6 pt-sm-4 pt-2" no-gutters>
          <v-col class="pr-xl-4 pr-lg-4 pr-md-4 mt-xl-0 mt-lg-0 mt-md-0 mt-sm-2 mt-2" xl="6" lg="6" md="6" sm="12" cols="12">
            <v-select v-model="shipping.region"
              :items="departments"
              item-text="name"
              item-value="code"
              label="Departamento"
              hint="Requerido"
              :rules="[isRequired]"
              @change="changeDepartament"
              persistent-hint
              :outlined="$vuetify.breakpoint.mdAndUp"
              :filled="$vuetify.breakpoint.smAndDown"
              :loading="loadingDepartments"
              dense
              return-object>
            </v-select>
          </v-col>
          <v-col class="mt-xl-0 mt-lg-0 mt-md-0 mt-sm-4 mt-4" xl="6" lg="6" md="6" sm="12" cols="12">
            <v-select v-model="shipping.city"
              :items="cities"
              item-text="name"
              item-value="code"
              label="Ciudad"
              hint="Requerido"
              :rules="[isRequired]"
              :disabled="!cities || !cities.length"
              @change="changeCity"
              :loading="loadingCities || loadingShippingCost"
              persistent-hint
              :outlined="$vuetify.breakpoint.mdAndUp"
              :filled="$vuetify.breakpoint.smAndDown"
              dense
              return-object>
            </v-select>
          </v-col>
        </v-row>
        <v-row class="mt-6" no-gutters v-if="error">
          <v-col cols="12" class="text-left">
            <v-alert text prominent type="error" icon="location_on">
              {{ errorMessage }}
            </v-alert>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { cloneObject } from '@/shared/clone'
import { getErrorMessage } from '@/shared/errors'
import { isRequired } from '@/shared/validations'

export default {
  name: 'ShippingForm',
  data () {
    return {
      isRequired,
      loadingDepartments: false,
      loadingCities: false,
      loadingShippingCost: false,
      errorMessage: null,
      shipping: {
        region: '',
        city: ''
      }
    }
  },
  props: {
    totalValue: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState('shared', ['error']),
    ...mapState('shipping', ['shippingInput', 'departments', 'cities'])
  },
  methods: {
    ...mapMutations('shipping', ['setShippingInfo', 'setShippingInput']),
    ...mapActions('shipping', ['getDepartments', 'getCities', 'getDeliveryTypes']),
    async changeDepartament (region) {
      if (!region) {
        return
      }

      this.loadingCities = true
      this.shipping.city = {}
      await this.getCities(region.code)
      this.loadingCities = false
    },
    async changeCity (city) {
      if (!city) {
        return
      }

      this.setShippingInfo(null)

      this.loadingShippingCost = true
      await this.getDeliveryTypes({ cityID: city.code, totalValue: this.totalValue })
      this.setShippingInput(this.shipping)
      this.loadingShippingCost = false

      if (this.error) {
        this.errorMessage = getErrorMessage('shipping_form', this.error)
        return
      }

      this.$emit('selectedLocation')
    }
  },
  async mounted () {
    this.loadingDepartments = true
    await this.getDepartments()
    this.shipping = cloneObject(this.shippingInput)
    this.loadingDepartments = false
  }
}
</script>
